
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { filter, Subject, Subscription, takeUntil } from 'rxjs';
import { BasketService } from 'src/app/services/basket.service';
import { Food } from 'src/interfaces/food.model';
import { Drink } from 'src/interfaces/drink.model';
import { DataService } from 'src/app/services/data.service';
import { ScrollService } from 'src/app/services/scroll.service';
import { MatDialog } from '@angular/material/dialog';
import { MenuBasketDialogComponent } from '../menu-basket-dialog/menu-basket-dialog.component';
import { sheetDialogConfig } from 'src/app/directives/sheet.directive';

@Component({
    selector: 'app-menu-basket',
    templateUrl: './menu-basket.component.html',
    styleUrls: ['./menu-basket.component.css'],
    standalone: false
})
export class MenuBasketComponent implements OnInit, OnDestroy {
  constructor(
    public dataService: DataService,
    private basketService: BasketService,
    private scrollService: ScrollService,
    private dialog: MatDialog
  ) {
  }

  foods: Food[] = [];
  foodsCount: number = 0;
  drinks: Drink[] = [];
  drinksCount: number = 0;
  total: number = 0;
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.basketService.foods
    .pipe(takeUntil(this.destroy$))
    .subscribe((data: Food[]) => {
      this.foods = data;
      this.updateBasketPrice();
      // console.log('MenuBasket | ngOnInit() | foods:', this.foods.map(x => x.title).join(', '));
    });

    this.basketService.drinks
    .pipe(takeUntil(this.destroy$))
    .subscribe((data: Drink[]) => {
      this.drinks = data;
      this.updateBasketPrice();
      // console.log('MenuBasket | ngOnInit() | drinks:', this.drinks.map(x => x.title).join(', '));
    });
  }

  // Публичное свойство для доступа к сигналу locale
  get locale() {
    return this.dataService.locale;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onBasketClicked(): void {
    // Затемняем строку состояния перед открытием модального окна
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#a6a6ae');

    this.scrollService.setScrollEnabled(false);
    const dialogRef = this.dialog.open(MenuBasketDialogComponent, sheetDialogConfig());

    dialogRef.afterClosed().subscribe(() => {
      this.scrollService.setScrollEnabled(true);

      // Возвращаем исходный цвет строки состояния
      document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#f5f5ff');
    });
  }

  private updateBasketPrice(): void {
    let total = 0;
    this.foodsCount = 0;
    this.drinksCount = 0;

    // Проход по каждому блюду
    this.foods.forEach(food => {

      // Считаем стоимость блюда с учетом количества
      this.foodsCount += food.count;
      total += food.totalPrice * food.count;
    });

    this.drinks.forEach(drink => {

      // Считаем стоимость напитка с учетом количества
      this.drinksCount += drink.count;
      total += drink.totalPrice * drink.count;
    });

    // Обновляем стоимость корзины
    this.total = total;
  }
}
